import React from 'react'

const Contact = () => {
  return (
    <div className='bg-white min-h-[calc(100vh-4em)]'>Contact</div>
  )
}

export default Contact